module.exports = __webpack_public_path__ + "24e004ab/img/revit-icon.5ff0d581.svg";